import measureText from './measureText';
import { Style } from 'utils/types/Style';

/*
 * Manual truncating of text to the given width with an ellipsis for SVG
 */
export default function ellipsisToWidth(
    text: string,
    width: number,
    style?: Partial<Style>,
    context?: CanvasRenderingContext2D
): string {
    if (measureText(text, style, context) <= width) {
        return text;
    }
    for (let i = 0; i < text.length; i++) {
        const ret = text.slice(0, text.length - i - 1) + '...';
        if (measureText(ret, style, context) <= width) {
            return ret;
        }
    }
    return '...';
}
